module.exports = ['get', 'put', 'post', 'delete', 'options', 'head', 'patch'];



/*****************
 ** WEBPACK FOOTER
 ** ./~/swagger-parser/~/swagger-methods/lib/index.js
 ** module id = 232
 ** module chunks = 0
 **/